export default function getLignesCommandesWithType(lignesCommandes, type) {
  return lignesCommandes.filter((ligne) => { return ligne.typeProduit === type; });
}
